import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Landing from "../pages/Landing";

/**
 * Route "/" decides what to show:
 *  - Not logged in → public marketing Landing
 *  - Creator → /creator (Upload Studio)
 *  - Buyer → /catalog
 *  - Admin → /admin
 * Keeps Landing accessible for logged-in users via /home.
 */
export default function HomeRouter() {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen bg-ink-300 flex items-center justify-center">
                <div className="w-10 h-10 border-2 border-platinum/30 border-t-platinum rounded-full animate-spin" />
            </div>
        );
    }
    if (!user) return <Landing />;
    if (user.role === "creator") return <Navigate to="/creator" replace />;
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    return <Navigate to="/catalog" replace />;
}
